import { Component } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Indicateur, IndicateurPerformance } from 'src/app/shared/models/indicateurs';
import { ParameterService } from 'src/app/shared/service/params/param';
import { IndicateurServiceService } from '../indicateur-performance/indicateur-performance.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constant } from 'src/app/shared/service/utils/contant';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-add-indicateur-performance',
  standalone: false,
  templateUrl: './add-indicateur-performance.component.html',
  styleUrl: './add-indicateur-performance.component.scss'
})

export class AddIndicateurPerformanceComponent {

  item: IndicateurPerformance= new IndicateurPerformance()
  projetData:any=[];
  typeIndicateurData:any=[];
  actionItems:any=[];

  constructor(
    private modalService: NgbModal,
    private paramService:ParameterService,
    private FecthDataService:FecthDataService,
    private messageService :MessageService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(){
    this.fetchDataProjet();
  }

  close(){
    this.modalService.dismissAll();
  }

  //ajout dindicateur
  addIndicateur(){
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });
    }
    if (this.item.canSave()) {
      this.ngxService.start();
      this.paramService.addIndicateursPerformance(this.item).subscribe(
        (response:any)=>{
          ////console.log("la reponse du webservice",response);
  
          this.modalService.dismissAll();
          this.FecthDataService.notifySeriviceCreated();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message});
          this.ngxService.stop();
        },
        (error:any)=>{
          ////console.log("une erreur est survenu",error);
        //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessaye" });
          this.ngxService.stop();
        }
      )
    }
  }//end addIndicateur

  //recup projet
  fetchDataProjet() {
    this.paramService.fetchDataProgramme().subscribe(
      (response:any)=>{
        this.projetData = response.data;
        ////console.log("this.projetData",this.projetData);
            this.getIndicateurProjet();

      },
      (error)=>{
        ////console.log("une erreur est survenu",error);
      }
    ) ;
  }//end fetchDataProjet

  //recup indicateur
  getIndicateurProjet() {
    this.paramService.fetchTypeIndicateur().subscribe(
      (response:any)=>{
        this.typeIndicateurData = response.data;
        ////console.log("this.projetData",this.typeIndicateurData);
      },
      (error)=>{
        ////console.log("une erreur est survenu",error);
      }
    ) ;
  }//end getIndicateurProjet

    getActionByPrograme(item:any){
    this.paramService.getActionByProgramme(item).subscribe(
      (response:any)=> {
        //console.log("la réponse du webservice",response);
        this.actionItems = response.data;

      },
      (error:any)=>{
        //console.log("une erreur est survenu",error);
        
      }
    )
  }
}